export default function headerInit() {
  // const bodyClasses = document.body.classList;
  // const header = document.getElementById("main-header");
}
